<template>
    <div :class="windowWidth <= 991 ? 'container-fluid' : 'container'" v-if="uiTranslationsLoaded">
        <slot />
    </div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import { locales } from '../plugins/i18n'
import { switchDocumentLocale } from '../services/i18n/util'
import { setUiLocale, t, currentLocale } from '../services/i18n'
export default {
    data() {
        return {
            uiTranslationsLoaded: false,
            windowWidth: 0,
            windowHeight: 0
        }
    },
    methods: {
        set(locale) {
            this.uiTranslationsLoaded = false
            setUiLocale(locale)
                .then(() => {
                    Vue.prototype.$t = t
                    this.uiTranslationsLoaded = true
                    const dir = _.find(locales, l => l.code === locale).dir
                    switchDocumentLocale(
                        locale,
                        dir,
                        {
                            withRTL: [
                                '/static/styles/vendor/GhalamborM/bootstrap4-rtl.css',
                                '/static/styles/rtl.css',
                            ],
                        },
                    )
                })
                /* eslint-disable no-console */
                .catch(err => console.error(err))
        },
        getWindowWidth(event) {
            this.windowWidth = document.documentElement.clientWidth;
        },
        getWindowHeight(event) {
            this.windowHeight = document.documentElement.clientHeight;
        }
    },
    mounted() {
        this.set(this.$route.params.locale)
        this.$nextTick(function() {
            window.addEventListener('resize', this.getWindowWidth);
            window.addEventListener('resize', this.getWindowHeight);

            //Init
            this.getWindowWidth()
            this.getWindowHeight()
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getWindowWidth);
        window.removeEventListener('resize', this.getWindowHeight);
    },
    watch: {
        /* eslint-disable object-shorthand */
        '$route'(to) {
            if (to.params.locale !== currentLocale()) {
                this.set(to.params.locale)
            }
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/Localizer.vue